<script lang="ts">
    import { _ } from 'svelte-i18n';

    import { RouteSummaryData, type RouteSummaryDataRouteTypeType } from './RouteSummaryData.js';
    import { debug, deliveryList } from '../../../../../stores/store.js';
    import SuccessColor from '../../../../shared/SuccessColor.svelte';
    import ErrorColor from '../../../../shared/ErrorColor.svelte';
    import IconPending from '../../../../shared/Icons/IconPending.svelte';
    import Distance from '../../../../shared/Distance.svelte';
    import Duration from '../../../../shared/Duration.svelte';
    import Checkbox from '../../../../shared/Checkbox/Checkbox.svelte';
    import { RouteInfoUtils } from './RouteInfoUtils';
    import { Assignment } from '../../Assignment';
    import './RouteSummary.css';
    import { rsa } from './rsa';
    import Opacity from '../../../../shared/Opacity.svelte';
    import CalcRouteButton from '../../CalcRouteButton.svelte';
    import IconSubdirectoryRight from '../../../../shared/Icons/IconSubdirectoryRight.svelte';
    import ButtonSmallBlueRounded from '../../../../shared/ButtonSmallBlueRounded.svelte';
    import { smartRounding } from '../../../telematics/tools/smartRounding';
    import { RouteSummaryApp } from './RouteSummaryApp';
    import { tooltip } from '@svelte-plugins/tooltips';
    import IconError from '../../../../shared/Icons/IconError.svelte';
    import RouteSummaryAlerts from './RouteSummaryAlerts.svelte';
    import VehicleLimitExceededIcons from '../../VehicleLimitExceededIcons.svelte';
    import RouteCostDetails from '../../PageScenario/RouteCostDetails.svelte';
    import { reactiveTooltip } from '../../../../utilities/reactiveTooltip.js';

    export let route: RouteSummaryData;
    export let selectedRouteType: RouteSummaryDataRouteTypeType;
    export let scale: number = 1;
    export let assignment: Assignment;
    export let noValueChar: string = '-';
    export let showCheckbox: boolean = true;
    export let italicStyle: boolean = false;
    export let checkboxDisabled: boolean = false;
    export let onChange: (routeType: RouteSummaryDataRouteTypeType) => void;
    export let loading: boolean = false;
    export let disabled: boolean = false;
    export let hidden: boolean = false;

    let costDiff: number | null = null;
    let distanceDiff: number | null = null;
    let durationDiff: number | null = null;
    let disabledToggle: boolean = false;

    export let actionInProgress: boolean;
    let costDiffHumanFriendly: string = '';

    let currentAlerts: string = '';
    let reloadAlerts: boolean = false;

    costDiff = $rsa.getRouteCostDiff(route.routeType);
    distanceDiff = $rsa.getRouteDistanceDiff(route.routeType);
    durationDiff = $rsa.getRouteDurationDiff(route.routeType);
    if (costDiff) {
        costDiffHumanFriendly = new smartRounding().getFormatedValue(costDiff, '', {
            convert_nicer: true,
        });
    }

    $: {
        costDiff = $rsa.getRouteCostDiff(route.routeType);
        distanceDiff = $rsa.getRouteDistanceDiff(route.routeType);
        durationDiff = $rsa.getRouteDurationDiff(route.routeType);
        if ($debug) {
            costDiff = 123000;
            distanceDiff = 123000;
            durationDiff = 123000;
        }
        if (costDiff) {
            costDiffHumanFriendly = new smartRounding().getFormatedValue(costDiff, '', {
                convert_nicer: true,
            });
        }

        if (currentAlerts && currentAlerts != JSON.stringify(route.alerts)) {
            reloadAlerts = true;
            setTimeout(function () {
                reloadAlerts = false;
            }, 0);
        }
        currentAlerts = JSON.stringify(route.alerts);
    }
    // if route.routeType !== 'current_in_realisation' &&

    $: disabledToggle =
        route.quantity === 0 ||
        route.quantity === null ||
        loading ||
        route.isLoading ||
        checkboxDisabled;
</script>

<div class="route-summary-row" class:route-summary-row-italic={italicStyle} class:route-summary-row-hidden={hidden}>
    <div class="_checkbox">
        {#if loading || route.isLoading}
            <Opacity>
                <IconPending spin={true} {scale} />
            </Opacity>
        {:else if route.routeType === 'modified_by_operator'}
            <IconSubdirectoryRight scale={0.6} />
        {:else if showCheckbox}
            <Checkbox
                disabled={disabledToggle}
                checked={selectedRouteType === route.routeType}
                mode="black-radio"
                label=""
                onChange={() => {
                    onChange(route.routeType);
                    // selectedRouteType = route.routeType;
                    // $deliveryList.triggerReload = true;
                }}
            />
        {/if}
    </div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="desc bold"
        data-desc={route.routeType}
        on:click={() => {
            if (disabledToggle) {
                console.log('disabledToggle', disabledToggle);
            } else {
                onChange(route.routeType);
            }
        }}
    >
        {#if route.routeType === 'current_in_realisation' || route.routeType === 'modified_by_operator'}
            <div class="dont-break" style="text-transform: lowercase">{$_(route.title)}</div>
        {/if}

        {#if route.routeType === 'base_route'}
            {#if (!assignment.isDownloaded() || assignment.isRouteModifiedAfterDownload()) && assignment.isLocked()}
                <div class="dont-break" style="text-transform: lowercase">
                    {$_('has_been_send')}
                </div>
            {:else if assignment.isDownloaded()}
                <div class="dont-break" style="text-transform: lowercase">
                    {$_('in_realisation')}
                </div>
            {:else}
                <div class="dont-break" style="text-transform: lowercase">{$_(route.title)}</div>
            {/if}
        {/if}

        {#if route.routeType === 'to_confirm' || route.routeType === 'to_assign'}
            <div class="dont-break another-route-title" style="text-transform: lowercase">
                {#if $debug}
                    {route.routeType}
                {/if}
                {#if route.title !== ''}
                    +&nbsp;{$_(route.title)}
                {/if}
            </div>
        {/if}

        {#if route.quantity !== null && route.quantity > 0 && route.routeType === 'base_route' && !$deliveryList.isRouteVariantVisible}
            {#if assignment.isRouteInCalculation()}
                <Opacity>
                    <IconPending spin={true} {scale} />
                </Opacity>
            {:else if !assignment.isLocked() && !assignment.isRouteOrderModified()}
                <CalcRouteButton
                    disabled={loading || route.isLoading || disabled}
                    bind:assignment
                    displayMode="small"
                    lockAssignmentAfterCalculation={true}
                    onStartCalc={() => {
                        actionInProgress = true;
                    }}
                    onFinishCalc={() => {
                        actionInProgress = false;
                        onChange('current_in_realisation');
                    }}
                />
            {/if}
        {/if}

        {#if route.routeType === 'modified_by_operator' && !loading && !actionInProgress}
            <div
                style="display: flex; align-items: center; justify-content: flex-end; column-gap: 0;"
            >
                {#if $debug}
                    <div>
                        <div>actionInProgress:{actionInProgress}</div>
                        <div>route.routeType:{route.routeType}</div>
                        <div>loading:{loading}</div>
                    </div>
                {/if}
                <ButtonSmallBlueRounded
                    {disabled}
                    displayMode="small"
                    colorMode="danger"
                    dataId="modified-by-operator-discard"
                    text={$_('Cancel')}
                    on:click={evt => {
                        evt.stopPropagation();
                        console.log('modified-by-operator-discard, click1');
                        actionInProgress = true;
                        setTimeout(() => {
                            $rsa.executeAction(
                                RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_DISCARD,
                                () => {
                                    actionInProgress = false;
                                }
                            );
                        }, 0);
                    }}
                />
                <ButtonSmallBlueRounded
                    {disabled}
                    displayMode="small"
                    dataId="modified-by-operator-confirm"
                    text={$_('OK')}
                    on:click={evt => {
                        evt.stopPropagation();
                        console.log('modified-by-operator-confirm, click2');
                        actionInProgress = true;
                        setTimeout(() => {
                            $rsa.executeAction(
                                RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_COMMIT,
                                () => {
                                    actionInProgress = false;
                                }
                            );
                        }, 0);
                    }}
                />
            </div>
        {/if}

        {#if route.routeType === 'to_confirm' && !actionInProgress && !hidden && $rsa.isButtonConfirmAllShouldBeVisible()}
            <div
                style="display: flex; align-items: center; justify-content: flex-end; column-gap: 0;"
            >
                <ButtonSmallBlueRounded
                    {disabled}
                    displayMode="small"
                    dataId="confirmAllToConfirm"
                    text={$_('confirm')}
                    on:click={() => {
                        console.log('confirmAllToConfirm, click2');
                        actionInProgress = true;
                        hidden = true;
                        setTimeout(() => {
                            $rsa.executeAction('confirmAllToConfirm', () => {
                                actionInProgress = false;
                            });
                        }, 0);
                    }}
                />
            </div>
        {/if}
    </div>
    <div
        class="deliveries"
        class:blured={loading || route.isLoading}
        style="display: flex; align-items: center; column-gap: 4px;"
    >
        {#if route.routeType === 'base_route' || route.routeType === 'current_in_realisation' || route.routeType === 'modified_by_operator'}
            {#if !reloadAlerts && !loading && !route.isLoading}
                <VehicleLimitExceededIcons
                    {assignment}
                    routeType={route.routeType}
                    vehicle={assignment.getVehicle()}
                    warningThreshold={0}
                    position="bottom"
                />
            {/if}
        {/if}
        <div
            title={$_('Quantity of stops')}
            class="bold values"
            class:opacity-value={route.routeType === 'to_confirm' ||
                route.routeType === 'to_assign'}
        >
            {#if !hidden && route.stops !== null && route.stops >= 0}
                {route.stops}
                {#if 0 && route.timeWindowsExceeded && route.timeWindowsExceeded > 0}
                    <span
                        title={$_('Exceeded time windows')}
                        style="position: relative; margin-left: 2px; font-size: 12px;"
                    >
                        <ErrorColor>
                            ({route.timeWindowsExceeded})
                        </ErrorColor>
                    </span>
                {/if}
            {:else}
                {noValueChar}
            {/if}
        </div>
        {#if !hidden && route.quantity !== null}
            <div style="font-size: 12px; display: flex; opacity: 0.5;" title={$_('Quantity of deliveries')}>
                <div>/</div>
                <div style="font-weight: 600;">{route.quantity}</div>
            </div>
        {/if}
        {#if false && route.alerts && Object.values(route.alerts).reduce((sum, v) => sum + v, 0) > 0}
            {#if !reloadAlerts}
                <div
                    use:tooltip={{
                        content: { component: RouteSummaryAlerts, props: { alerts: route.alerts } },
                        theme: 'lastmile-tooltip',
                        position: 'bottom',
                        maxWidth: 400,
                    }}
                    style="align-self: center"
                >
                    <IconError scale={0.7} />
                </div>
            {/if}
        {/if}
    </div>

    <div class="metrics" class:blured={loading || route.isLoading}>
        {#if !hidden && route.durationSeconds !== null}
            <div style="display: flex;">
                {#if route.distanceMeters !== null}
                    {#if (route.routeType === 'modified_by_operator' || (route.routeType === 'base_route' && $rsa.isBaseRouteComparable())) && distanceDiff !== null}
                        <div
                            class="difference-container {route.routeType === 'base_route'
                                ? 'with-accent'
                                : ''}"
                        >
                            {#if Math.round(distanceDiff) === 0}
                                +0
                            {:else if distanceDiff >= 0}
                                +<Distance meters={distanceDiff} estimation={route.isEstimated} />
                            {:else}
                                <Distance meters={distanceDiff} estimation={route.isEstimated} />
                            {/if}
                        </div>
                    {:else}
                        <Distance
                            meters={$debug ? 1234567 : route.distanceMeters}
                            estimation={route.isEstimated}
                        />
                    {/if}
                {:else}
                    {noValueChar}
                {/if}
            </div>
            <div style="opacity: 0.4; padding: 0 3px; font-weight: 200;">|</div>
            <div style="display: flex;">
                {#if route.durationSeconds !== null}
                    {#if (route.routeType === 'modified_by_operator' || (route.routeType === 'base_route' && $rsa.isBaseRouteComparable())) && durationDiff !== null}
                        <div
                            class="difference-container {route.routeType === 'base_route'
                                ? 'with-accent'
                                : ''}"
                        >
                            {#if Math.round(durationDiff) === 0}
                                +0
                            {:else if durationDiff >= 0}
                                +<Duration seconds={durationDiff} estimation={route.isEstimated} />
                            {:else}
                                <Duration seconds={durationDiff} estimation={route.isEstimated} />
                            {/if}
                        </div>
                    {:else}
                        <Duration
                            seconds={$debug ? 1234567 : route.durationSeconds}
                            estimation={route.isEstimated}
                        />
                    {/if}
                {:else}
                    {noValueChar}
                {/if}
            </div>
            <div style="opacity: 0.4; padding: 0 3px; font-weight: 200;">|</div>
            <div
                use:reactiveTooltip={{enabled: route.cost && route.costDetails !== null, content: {component: RouteCostDetails, props: {total: route.cost, details: route.costDetails, currency: RouteInfoUtils.getCurrency()}}, theme: 'lastmile-tooltip', position: 'bottom', maxWidth: 400}}
                data-costDiff={JSON.stringify(costDiff)}
                style="display: flex;"
            >
                {#if route.routeType === 'to_confirm' || (route.routeType === 'base_route' && $rsa.isBaseRouteComparable()) || route.routeType === 'modified_by_operator'}
                    {#if costDiff !== null}
                        <div
                            class="difference-container {route.routeType === 'base_route'
                                ? 'with-accent'
                                : ''}"
                        >
                            {#if Math.round(costDiff) === 0}
                                +0 {RouteInfoUtils.getCurrency()}
                            {:else if route.routeType === 'base_route'}
                                {#if costDiff >= 0}
                                    <div class="dont-break">
                                        +{costDiffHumanFriendly}
                                        {RouteInfoUtils.getCurrency()}
                                    </div>
                                {:else}
                                    <div class="dont-break">
                                        {costDiffHumanFriendly}
                                        {RouteInfoUtils.getCurrency()}
                                    </div>
                                {/if}
                            {:else if costDiff >= 0}
                                <ErrorColor>
                                    <div class="dont-break">
                                        +{costDiffHumanFriendly}
                                        {RouteInfoUtils.getCurrency()}
                                    </div>
                                </ErrorColor>
                            {:else}
                                <SuccessColor>
                                    <div class="dont-break">
                                        {costDiffHumanFriendly}
                                        {RouteInfoUtils.getCurrency()}
                                    </div>
                                </SuccessColor>
                            {/if}
                        </div>
                    {:else if route.cost !== null}
                        {new smartRounding().getFormatedValue(route.cost, '', {convert_nicer: true})} {RouteInfoUtils.getCurrency()}
                    {/if}
                {:else if route.cost !== null}
                    {new smartRounding().getFormatedValue(route.cost, '', {convert_nicer: true})} {RouteInfoUtils.getCurrency()}
                {:else}
                    {noValueChar}
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .opacity-value {
        opacity: 0.5;
    }
    .route-summary-row-italic {
        font-style: italic;
    }
    .route-summary-row-italic .bold {
        font-weight: 500;
    }
    .route-summary-row-hidden {
        opacity: 0.3;
        pointer-events: none;
    }
    .desc {
        cursor: pointer;
        width: 220px;
    }
    .difference-container {
        display: flex;
    }
    .with-accent {
        color: var(--planning-page-accent-color);
    }
    .metrics {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
    }
    .blured {
        filter: blur(2px);
        opacity: 0.5;
    }
</style>
